// avatares.js — La galería de avatares que puede elegir cada persona.
//
// Vienen seis de serie —tres mujeres (av1-av3) y tres hombres (av4-av6),
// dibujos planos servidos como SVG desde el backend— y cada proyecto puede
// cambiarlos o poner los suyos en `config_json.avatares`: una lista de rutas
// dentro de `uploads/`.
export const AVATARES_BASE = [
  'uploads/avatars/base/av1.svg',
  'uploads/avatars/base/av2.svg',
  'uploads/avatars/base/av3.svg',
  'uploads/avatars/base/av4.svg',
  'uploads/avatars/base/av5.svg',
  'uploads/avatars/base/av6.svg',
];

// Lista efectiva del proyecto: la suya si configuró alguna, si no la de serie.
export const avataresDeProyecto = (proyecto) => {
  const lista = proyecto?.config_json?.avatares;
  const limpias = Array.isArray(lista) ? lista.filter(v => typeof v === 'string' && v.trim() !== '') : [];
  return limpias.length ? limpias : AVATARES_BASE;
};

// Ruta absoluta para pintarla: las de `uploads/` cuelgan del backend.
export const urlAvatar = (ruta, backendBase = '') => {
  if (!ruta) return '';
  if (/^https?:\/\//i.test(ruta)) return ruta;
  return `${backendBase}/${String(ruta).replace(/^\//, '')}`;
};

export default AVATARES_BASE;
